import {
  Button,
  Card,
  Divider,
  Grid,
  Icon,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tabs
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import Api, { apiPaths } from '../../../services/api';
import { getFormModAndID } from '../../smart-kit/Form/gridFormUtils';

const cols = [
  { label: 'Type', key: 'type' },
  { label: 'Address', key: 'address' },
  { label: 'Email', key: 'email' },
  { label: 'Phone Number', key: 'phone_number' },
  { label: 'Industry', key: 'industry' },
  { label: 'Website', key: 'website' }
];

const InsuranceView = (props) => {
  const { uuid } = getFormModAndID();

  const [tabValue, setTabValue] = useState(0);
  const [entity, setEntity] = useState();

  useEffect(() => {
    (async () => {
      const data = await Api.get(`${apiPaths.COMPANIES}/${uuid}`);
      setEntity(data);
    })();
  }, []);

  const handleTabChange = (e, newValue) => {
    setTabValue(newValue);
  };

  if (entity)
    return (
      <div className="m-sm-30">
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Details" />
          <Tab label="Courses" />
          <Tab label="Start Course" />
        </Tabs>
        <Divider className="mb-6" />

        {tabValue === 0 && (
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={4}>
              <Card elevation={3} className="pt-6">
                <div className="flex-column items-center mb-6">
                  <h4>{entity.name}</h4>
                </div>
                <Divider />
                <Table className="mb-4">
                  <TableBody>
                    {cols.map((col, i) => (
                      <TableRow key={i}>
                        <TableCell className="pl-4">{col.label}</TableCell>
                        <TableCell>{entity[col.key]}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <div className="flex-column items-start px-4 mb-4">
                  <Button variant="outlined" onClick={() => setTabValue(2)}>
                    <Icon>books</Icon>
                    Start Course
                  </Button>
                </div>
              </Card>
            </Grid>
          </Grid>
        )}
      </div>
    );
  else return <></>;
};

export default InsuranceView;
